export default __webpack_public_path__ + "static/media/p1.cdf274d5.png";